"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _react = _interopRequireDefault(require("react")),
    _TabsContext = require("./TabsContext"),
    _Tab = _interopRequireDefault(require("./Tab"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _typeof(a) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(a, b) {
  for (var c, d = 0; d < b.length; d++) {
    c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
}

function _createClass(a, b, c) {
  return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}

function _possibleConstructorReturn(a, b) {
  return b && ("object" === _typeof(b) || "function" == typeof b) ? b : _assertThisInitialized(a);
}

function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(a);
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), b && _setPrototypeOf(a, b);
}

function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

var ListTabs = function ListTabs(a) {
  var b = a.children;
  return _react.default.createElement("ul", {
    style: {
      paddingLeft: 0,
      listStyle: "none",
      margin: 0
    }
  }, b);
},
    TabTitleItem = function TabTitleItem(a) {
  var b = a.children,
      c = a.innerRef,
      d = _objectWithoutProperties(a, ["children", "innerRef"]);

  return _react.default.createElement("li", _extends({
    ref: c,
    style: {
      display: "inline-block",
      transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    }
  }, d), b);
},
    ActiveTabBorder = function ActiveTabBorder(a) {
  var b = a.activeTabElement,
      c = a.children,
      d = _objectWithoutProperties(a, ["activeTabElement", "children"]),
      e = {
    height: 4,
    backgroundColor: "#0088dd",
    position: "absolute",
    bottom: 0,
    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    willChange: "left, width"
  };

  return b && (e.width = b.offsetWidth, e.left = b.offsetLeft), _react.default.createElement("div", _extends({
    style: e
  }, d), c);
},
    TabAnchorItem = function TabAnchorItem(a) {
  var b = a.isActiveTab,
      c = a.children,
      d = _objectWithoutProperties(a, ["isActiveTab", "children"]),
      e = {
    textTransform: "capitalize",
    color: "#000000",
    fontWeight: 600,
    padding: "16px 30px",
    cursor: "pointer",
    opacity: "0.4",
    display: "block",
    textDecoration: "none",
    ":hover": {
      opacity: 1
    }
  };

  return b && (e.transition = "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", e.cursor = "default", e.opacity = 1), _react.default.createElement("a", _extends({
    style: e
  }, d), c);
},
    TabsContainer = function TabsContainer(a) {
  var b = a.children,
      c = _objectWithoutProperties(a, ["children"]);

  return _react.default.createElement("div", _extends({
    style: {
      position: "relative",
      borderBottom: "1px solid #dfdfdf"
    }
  }, c), b);
},
    ReactTabs = function ReactTabs(a) {
  var b = a.children,
      c = _objectWithoutProperties(a, ["children"]);

  return _react.default.createElement("div", _extends({
    style: {
      position: "realative"
    }
  }, c), b);
},
    Tabs = /*#__PURE__*/function (a) {
  function b() {
    var a, c;

    _classCallCheck(this, b);

    for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) {
      e[f] = arguments[f];
    }

    return c = _possibleConstructorReturn(this, (a = _getPrototypeOf(b)).call.apply(a, [this].concat(e))), _defineProperty(_assertThisInitialized(c), "state", {
      tabsElements: []
    }), c;
  }

  return _inherits(b, a), _createClass(b, [{
    key: "render",
    value: function b() {
      var a = this;
      return _react.default.createElement(_TabsContext.TabProvider, {
        activeTab: this.props.activeTab
      }, _react.default.createElement(_TabsContext.TabConsumer, null, function (b) {
        return _react.default.createElement(ReactTabs, null, _react.default.createElement(TabsContainer, null, _react.default.createElement(ListTabs, null, b.context.tabs.map(function (c, d) {
          return _react.default.createElement(TabTitleItem, {
            key: d,
            id: c.id,
            innerRef: function d(b) {
              a.state.tabsElements[c.id] || a.setState(function (a) {
                var d = a.tabsElements;
                return d[c.id] = b, {
                  tabsElements: d
                };
              });
            }
          }, _react.default.createElement(TabAnchorItem, {
            isActiveTab: b.context.activeTab.id === c.id,
            href: "javascript:void(0)",
            onClick: b.context.onClick(c),
            onKeyPress: function e(b) {
              var d = b.keyCode || b.which;
              13 === d && a.onClick(c)(b);
            }
          }, c.title));
        })), _react.default.createElement(ActiveTabBorder, {
          activeTabElement: a.state.tabsElements[b.context.activeTab.id]
        })), a.props.children);
      }));
    }
  }]), b;
}(_react.default.Component);

_defineProperty(Tabs, "Tab", _Tab.default);

var _default = Tabs;
exports.default = _default;